import React, { Component } from 'react'
import classNames from 'class-names'
import without from 'lodash.without'
import union from 'lodash.union'
import Toast from '../../components/Toast'
import MajorDetail from '../Major/Detail'
import iconAdd from '../../assets/svg/icon_add.svg'
import iconAdded from '../../assets/svg/icon_added.svg'
import './MajorDetail.less'

class Detail extends Component {

  state = {
    showToast: false,
    toastIcon: 'deleted',
    toastText1: '',
    toastText2: '',
  }

  handleAdd(major, added) {
    const { codes } = this.props
    const newCodes = added
      ? without(codes, major.code)
      : union(codes, [major.code])
    this.props.changeCodes(newCodes, 'majorDetail')
    this.setState(() => {
      return {
        showToast: true,
        toastIcon: added ? 'deleted' : 'success',
        toastText1: added ? '已删除' : '已添加',
        toastText2: major.name,
      }
    })
  }

  handleRecommendationClick(profession) {
    const { history } = this.props
    history.push(`/majorwishlist/profession/${profession.id}`)
  }

  handleBackToWish() {
    const { history } = this.props
    history.push(`/majorwishlist`)
  }
  handleBackToChoose() {
      const { history } = this.props
      history.push(`/majorwishlist/choose`)
  }

  renderBtn(major) {
    const { codes } = this.props
    const added = codes.includes(major.code)
    const cls1 = classNames({
      'btn-operation': true,
      'added': added,
    });
    return <div className={cls1} onClick={this.handleAdd.bind(this, major, added)}>
      <img className="icon-add" src={added ? iconAdded : iconAdd} alt="icon" />
      <span>{added ? '已选' : '选择'}</span>
    </div>
  }

  render() {
    const {
      showToast,
      toastIcon,
      toastText1,
      toastText2,
    } = this.state
    return (
      <div className="major-wish-list-wrapper">
        <MajorDetail
          renderOperationBtn={this.renderBtn.bind(this)}
          onRecommendationClick={this.handleRecommendationClick.bind(this)}
          onBack={this.handleBackToChoose.bind(this)}
          {...this.props} />
        <div className="bottom-btn">
          <button className="primary full" onClick={this.handleBackToWish.bind(this)}>返回意向专业清单</button>
        </div>
        <Toast show={showToast} icon={toastIcon} onHide={() => this.setState({ showToast: false })}>
          <i>{toastText1}</i>
          <p>{toastText2}</p>
        </Toast>
      </div>
    )
  }
}

export default Detail



// WEBPACK FOOTER //
// ./src/pages/MajorWishList/MajorDetail.js